export enum VideoType {
    YOUTUBE = 'youtube',
    YOUKU = 'youku',
    INTERNAL = 'internal',
    VBRICK_VISATV = 'vbrickVisaTv'
}

export enum VideoButtonStyle {
    BLACK = 'black',
    WHITE = 'white'
}
